import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const AdminLoginPage = () => {
  const [form, setForm] = useState({ phone: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { adminLogin } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await adminLogin(form.phone, form.password);
      if (user.is_staff) {
        toast.success('Welcome Admin!');
        navigate('/admin-dashboard');
      } else {
        toast.error('You are not authorized');
      }
    } catch (err) {
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="otp-page">
      <div className="otp-card">
        <div className="otp-card__icon">🔒</div>
        <h1 className="otp-card__title">Admin Login</h1>

        <form onSubmit={handleSubmit} className="otp-form">
          <div className="form-group" style={{ marginBottom: 16 }}>
<label className="form-label">Phone Number</label>
<input
  className="form-input"
  type="tel"
  placeholder="10-digit phone (without +91)"
  value={form.phone}
  onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
  required autoFocus
/>
          </div>

          <div className="form-group" style={{ marginBottom: 20 }}>
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              placeholder="Enter password"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary otp-submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;